// extracted by mini-css-extract-plugin
module.exports = {"note":"SuccessStepPage__note__N59E-","preset":"SuccessStepPage__preset__ndBcM","address":"SuccessStepPage__address__0+96Y"};